import React, { FC } from "react";

import { Link, LinkProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { IgTypography } from "./IgTypography";
import { ColorDisabled } from "./theme";

const StyledLink = styled(Link)(({ theme }) => ({
  color: ColorDisabled.main,
}));

interface IgTypographyProps extends LinkProps {
  disabled?: boolean;
}

/**
 * @see Link
 * @see IgTypography
 */
export const IgLink: FC<IgTypographyProps> = (props) => {
  const { children, disabled, sx, ...rest } = props;

  if (disabled) {
    return (
      <IgTypography disabled sx={sx} onClick={undefined} {...rest}>
        {children}
      </IgTypography>
    );
  }
  return (
    <Link
      {...rest}
      underline={"hover"}
      sx={{ "&:hover, &:focus": { cursor: "pointer" }, ...sx }}
    >
      {children}
    </Link>
  );
};
